import { Col, Form, Row } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { connect } from '../Notes/wrapper'
import { FormCheck, FormLabel } from '../Utilities/Form'
import { useInputDataState, useLabels } from '../../functions'
import { writeToRedis } from '../../state/customerAsyncActions'

export const InstallAlertPhoneConsent = () => {
    const labels = useLabels()
    const dispatch = useDispatch()

    const [contactInstallConsent, setContactInstallConsent] = useInputDataState('InstallAlertPhoneConsent')
    const [installAlertSMSConsent, setInstallAlertSMSConsent] = useInputDataState('installAlertSMSConsent')
    const [installAlertEmailConsent, setInstallAlertEmailConsent] = useInputDataState('installAlertEmailConsent')

    const saveToRedis = () => {
        setTimeout(() => {
            dispatch(writeToRedis())
        }, 0)
    }

    const onConsentChange = (event) => {
        const value = event.target.value

        setContactInstallConsent(event)

        if (value === 'Y') {
            setInstallAlertSMSConsent({
                target: {
                    value: 'Y',
                    checked: true,
                },
            })

            setInstallAlertEmailConsent({
                target: {
                    value: 'Y',
                    checked: true,
                },
            })
        }

        saveToRedis()
    }

    const onSMSConsentChange = (event) => {
        const checked = event.target.checked

        if (!checked && installAlertEmailConsent !== 'Y') {
            return
        }

        setInstallAlertSMSConsent({
            target: {
                value: checked ? 'Y' : 'N',
                checked,
            },
        })

        saveToRedis()
    }

    const onEmailConsentChange = (event) => {
        const checked = event.target.checked

        if (!checked && installAlertSMSConsent !== 'Y') {
            return
        }

        setInstallAlertEmailConsent({
            target: {
                value: checked ? 'Y' : 'N',
                checked,
            },
        })

        saveToRedis()
    }

    return (
        <Row className="mt-3 mb-3">
            <Col>
                <Form.Group>
                    <FormLabel bold={true}>
                        {labels.InstallAlertPhoneConsent}
                    </FormLabel>

                    <FormCheck
                        label={labels.yesOption}
                        type="radio"
                        value="Y"
                        onChange={onConsentChange}
                        checked={contactInstallConsent === 'Y'}
                    />

                    <FormCheck
                        label="No"
                        type="radio"
                        value="N"
                        onChange={onConsentChange}
                        checked={contactInstallConsent === 'N'}
                    />

                    {contactInstallConsent === 'Y' && (
                        <div className="ms-4 mt-2">
                            <FormCheck
                                label="SMS (text)"
                                type="checkbox"
                                onChange={onSMSConsentChange}
                                checked={installAlertSMSConsent === 'Y'}
                            />

                            <FormCheck
                                label="Email"
                                type="checkbox"
                                onChange={onEmailConsentChange}
                                checked={installAlertEmailConsent === 'Y'}
                            />
                        </div>
                    )}

                    {contactInstallConsent === 'N' && (
                        <div className="mt-2 text-danger fw-bold">
                            I'm sorry, but permission for the installer to contact you on your mobile phone is required to complete your order. I won't be able to proceed without it.
                        </div>
                    )}
                </Form.Group>
            </Col>
        </Row>
    )
}

export default connect(
    InstallAlertPhoneConsent,
    'install-alert-phone-consent'
)